export default "__VITE_ASSET__Dml4V6qJ__"